import React from "react";
import ReactDOM from "react-dom";

import { Router as RouterProvider } from "react-router-dom";
import { Provider as MobxProvider } from "mobx-react";
import moment from "moment";
import numeral from "numeral";
import CssBaseline from "@material-ui/core/CssBaseline";

import * as serviceWorker from "./serviceWorker";
import { providers, history } from "./stores/RootStore";

import App from "./containers/App";

import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";

require("../node_modules/moment/locale/pt-br");
moment.locale("pt-BR");

require("../node_modules/numeral/locales/pt-br");
numeral.locale("pt-br");

ReactDOM.render(
  <MobxProvider {...providers}>
    <RouterProvider history={history}>
      <CssBaseline />
      <App />
    </RouterProvider>
  </MobxProvider>,
  document.getElementById("root")
);

serviceWorker.register();
